<template>
  <banner :rounded="true" :showImage="false">
    <div class="flex text-white gap-4 md:gap-x-14 items-center justify-center">
      <img
        src="../assets/under-review-2.svg"
        alt="Person review the documents to imply that the application is under review"
        width="75"
        height="76"
        class="h-20 w-auto"
      />
      <div class="grid gap-1 md:flex">
        <div class="md:pr-40 md:pt-2">
          <p class="text-base font-semibold">Application under review</p>
          <p class="text-sm">Discrepancies found in documents uploaded</p>
        </div>
        <router-link
          :to="{ name: 'Application Discrepancy' }"
          class="
            btn btn--small
            font-semibold
            btn--white
            justify-self-start
            w-full md:w-72 md:h-11
            mt-1
          "
          >View All
        </router-link>
      </div>
    </div>
  </banner>
</template>
<script>
import Banner from './Banner.vue';

export default {
  name: 'DiscrepanciesFoundCard',
  components: {
    Banner,
  },
};
</script>
